import { FunctionComponent } from 'react'
import { Button, Form } from 'react-bootstrap'
import { useForm, useWatch } from 'react-hook-form'
import * as comments from 'Frontend/scripts/services/comments.services'
import { useTranslation } from 'react-i18next'

interface AddCommentProps {
  contentId: number
  onPostAdded: () => void
}

interface AddCommentForm {
  comment: string
}

const AddComment: FunctionComponent<AddCommentProps> = ({ contentId, onPostAdded }) => {
  const MAX_COMMENT_LENGTH = 3000
  const { t } = useTranslation()
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm<AddCommentForm>({})

  const onSubmit = (data: AddCommentForm) => {
    comments.createComment(contentId, data.comment).then(() => {
      onPostAdded()
      reset()
    })
  }

  const comment = useWatch({
    control,
    name: 'comment',
    defaultValue: '',
  })

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Form.Group controlId="comment">
        <Form.Label>{t('comments.comment-label')}</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          maxLength={MAX_COMMENT_LENGTH}
          placeholder={t('comments.comment')}
          isInvalid={errors.comment ? true : false}
          {...register('comment', {
            required: t('comments.create-comment-validation-message'),
            maxLength: {
              value: MAX_COMMENT_LENGTH,
              message: t('comments.comment-too-long'),
            },
          })}
        />
        <Form.Control.Feedback type="invalid">{errors.comment?.message}</Form.Control.Feedback>
        <Form.Text muted>
          {t('comments.nbr-of-characters-left', {
            currentCommentLength: MAX_COMMENT_LENGTH - comment.length,
            maxCommentLength: MAX_COMMENT_LENGTH,
          })}
        </Form.Text>
      </Form.Group>
      <Button className="mt-2" type="submit">
        {t('comments.comment')}
      </Button>
    </Form>
  )
}

export default AddComment
